module.exports = __webpack_public_path__ + "static/media/16295.7233b254.png";